module.exports = __webpack_public_path__ + "img/techViewLogo.e7fa1a90.jpg";